export default [
  {  path: '/notfound',  component: () => import('./components/NotFound.vue')},
  //{  path: '/home',  component: () => import('./components/page/home.vue')},

  { path: '/login', component: require('./components/auth/Login.vue').default },

  {  path: '/stats',  component: () => import('./components/page/StatisticsPage.vue')},

  {  path: '/user',  component: () => import('./components/page/user/userPage.vue')},
  {  path: '/userprofile/:id', component: ()  => import('./components/page/user/profilePage.vue'),props: true},

  {  path: '/permission',  component: () => import('./components/page/permission/PermPage.vue')},

  {  path: '/category',  component: () => import('./components/page/CategoryPage.vue')},

  {  path: '/comment/:id',name: 'comment', component: () => import('./components/page/CommentPage.vue'),props: true},

  {  path: '/applist',  component: () => import('./components/page/App/ApplicationPage.vue')},
  {  path: '/appver/:id',name: 'appver', component: ()  => import('./components/page/App/AppVerPage.vue'),props: true},

  {  path: '/appcreate/:id/:app_id',name: 'appcreate', component: ()  => import('./components/page/App/AppCreatePage.vue'),props: true},



	{  path: '/app', component: ()  => import('./components/page/site/index.vue')},
	{  path: '/doc', component: ()  => import('./components/page/site/DocPage.vue')},
	{  path: '/about', component: ()  => import('./components/page/site/AboutPage.vue')},
	{  path: '/support', component: ()  => import('./components/page/site/SupportPage.vue')},
	{  path: '/lic', component: require('./components/page/site/LicPage.vue').default },
  {  path: '/appdetail/:id/:app_ver_id/:system',name: 'details', component: ()  => import('./components/page/site/AppPage.vue'),props: true},
  {  path: '/appcat/:user_id', name: 'appcat',component: ()  => import('./components/page/site/AppListPage.vue'),props: true},


	{  path: '/docadd', component: ()  => import('./components/page/documentation/DocumentationApp.vue')},


  {  path: '/message', component: ()  => import('./components/page/MessagePage.vue')},



  // {  path: '/:pathMatch(.*)*', name: '404', component: NotFoundView}
];
